import React, { useState, useContext, useEffect } from "react";
import { Button, Upload, message } from "antd";
import ImgCrop from "antd-img-crop";

import PhotoProcessingModal from "../../PhotoProcessingModal/PhotoProcessingModal";

import {
  loadFaceApiModels,
  validatePhotoRequirements,
  validatePhotoRequirementsSDDModel,
  PhotoErrorMessages,
  loadFaceApiSSDModel,
} from "../FaceAPI";

const PhotoFileUpload = ({ value, onChange, onUpload }) => {
  const [modalOpen, SetModalOpen] = useState(false);
  const [isProcessing, SetIsProcessing] = useState(false);
  const [photoErrorMessages, SetPhotoErrorMessages] = useState([]);
  // Create a controlled fileList based on the accepted 'value' (dataURL).
  const fileList = value
    ? [
        {
          uid: "-1",
          name: "photo.jpg",
          status: "done",
          url: value,
        },
      ]
    : [];

  return (
    <>
      <PhotoProcessingModal
        isVisible={modalOpen}
        isLoading={isProcessing}
        errors={photoErrorMessages}
        onClose={() => {
          SetModalOpen(false);
        }}
      />
      <ImgCrop rotate aspect={35 / 45}>
        <Upload
          // Pass the controlled fileList to override AntD's internal state
          fileList={fileList}
          maxCount={1}
          accept=".png,.jpg,.jpeg"
          listType="picture-card"
          onRemove={() => {
            onChange(""); // Clear the value on remove
          }}
          // Removing the empty onChange handler

          beforeUpload={async (file) => {
            SetIsProcessing(true);
            SetModalOpen(true);
            SetPhotoErrorMessages([]);
            await loadFaceApiModels();
            await new Promise((resolve) => setTimeout(resolve, 1000));
            const dataUrl = await new Promise((resolve) => {
              const reader = new FileReader();
              reader.onload = (e) => resolve(e.target.result);
              reader.readAsDataURL(file);
            });

            let photoErrors = await validatePhotoRequirements(dataUrl);

            if (photoErrors.includes(PhotoErrorMessages.NoFaceDetected)) {
              const { error, message: modelMessage } =
                await loadFaceApiSSDModel();
              if (error) {
                message.error(modelMessage); // Ant Design message
              } else {
                message.success(modelMessage);
                photoErrors = await validatePhotoRequirementsSDDModel(dataUrl);
              }
            }

            SetPhotoErrorMessages(photoErrors);
            SetIsProcessing(false);

            if (photoErrors.length === 0) {
              // SUCCESS: Update parent state, which updates our controlled fileList
              onChange(dataUrl);
              // Return false to stop the network upload
              return false;
            } else {
              // FAILURE: Display error and block the thumbnail
              message.error(`Photo Rejected: ${photoErrors.join(" | ")}`);
              // Use UPLOAD.LIST_IGNORE to reliably block the file from the list
              return Upload.LIST_IGNORE;
            }
          }}
        >
          {/* Only show the button if no file is currently accepted */}
          {fileList.length === 0 && <Button>Select File</Button>}
        </Upload>
      </ImgCrop>
    </>
  );
};

export default PhotoFileUpload;
